const CalloutAnnotation = (props) => {
  const {
    x: xFunc,
    y: yFunc,
    datum,
    text: textProp,
    direction = "down",
    bg = "#e7eff3",
    stroke = "#a6b8c1",
    fill = "#000",
    fontFamily = "Helvetica, Arial, sans-serif",
    fontSize = 11,
    padding = 4,
    tailWidth = 10,
    tailHeight = 6,
    radius = 3,
    opacity = 1,
    xScale,
    yScale,
    xAccessor,
    width,          // 👈 chart width passed in
    isFirst = false,
    isLast = false, // 👈 new flags
  } = props;

  // Evaluate provided functions
  const x = typeof xFunc === "function" ? xFunc({ xScale, xAccessor, datum }) : xFunc;
  const y = typeof yFunc === "function" ? yFunc({ yScale, datum }) : yFunc;

  if (x == null || y == null) return null;

  const content = typeof textProp === "function" ? textProp(datum) : textProp ?? "";

  const approxChar = fontSize * 0.6;
  const w = Math.max(28, String(content).length * approxChar + padding * 2);
  const h = fontSize + padding * 2;

  // ✅ adjust positioning
// ✅ horizontal clamping
// horizontal placement
let boxX = x - w / 2;
if (isFirst) {
  // prevent cutting off on the left
  // boxX = Math.max(0, boxX);
} else if (isLast && width) {
  // prevent cutting off on the right
  boxX = Math.min(width - w - 4, boxX);
}

// vertical placement
let boxY = direction === "down" ? y - tailHeight - h : y + tailHeight;

// prevent cutting off at the top
if (boxY < 2) {
  boxY = 2;
}

// prevent cutting off at the bottom
const chartBottom = Math.max(...yScale.range()); // SVG bottom
if (boxY + h > chartBottom) {
  boxY = chartBottom - h - 2;
}


  // const points =
  //   direction === "down"
  //     ? `${x},${y} ${x - tailWidth / 2},${y - tailHeight} ${x + tailWidth / 2},${y - tailHeight}`
  //     : `${x},${y} ${x - tailWidth / 2},${y + tailHeight} ${x + tailWidth / 2},${y + tailHeight}`;

  const boxCenter = boxX + w / 2;

const points =
  direction === "down"
    ? `${boxCenter},${y} ${boxCenter - tailWidth / 2},${y - tailHeight} ${boxCenter + tailWidth / 2},${y - tailHeight}`
    : `${boxCenter},${y} ${boxCenter - tailWidth / 2},${y + tailHeight} ${boxCenter + tailWidth / 2},${y + tailHeight}`;


  const textY = boxY + h / 2 + fontSize * 0.35;

  return (
    <g pointerEvents="none" opacity={opacity}>
      <rect
        x={boxX}
        y={boxY}
        width={w}
        height={h}
        rx={radius}
        ry={radius}
        fill={bg}
        stroke={stroke}
      />
      <polygon points={points} fill={bg} stroke={stroke} />
      <text
        x={boxX + w / 2}
        y={textY}
        textAnchor="middle"
        fontFamily={fontFamily}
        fontSize={fontSize}
        fill={fill}
      >
        {content}
      </text>
    </g>
  );
};


export default CalloutAnnotation;